var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "reporting_channel_handling.configuration.create",
              expression: "'reporting_channel_handling.configuration.create'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew }
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" }
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew")))
          ])
        ],
        1
      ),
      _c("Grid", {
        ref: "grid",
        attrs: {
          service: _vm.service,
          route_name: "handling_status_configuration_index",
          route_grid_path: "grid",
          defaultOrderColumn: "id",
          defaultOrderDirection: "desc"
        },
        scopedSlots: _vm._u(
          [
            {
              key: "gridThead",
              fn: function() {
                return [
                  _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                    _vm._v("ID")
                  ]),
                  _c(
                    "vs-th",
                    {
                      key: "description",
                      attrs: { "sort-key": "description" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "reporting_channel.workflow_config.description"
                          )
                        )
                      )
                    ]
                  ),
                  _c(
                    "vs-th",
                    {
                      key: "legal_entity_name",
                      attrs: { "sort-key": "legal_entity_id" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "reporting_channel.workflow_config.legal_entity"
                          )
                        )
                      )
                    ]
                  ),
                  _c(
                    "vs-th",
                    { key: "created_at", attrs: { "sort-key": "created_at" } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("reporting_channel.workflow_config.created_at")
                        )
                      )
                    ]
                  )
                ]
              },
              proxy: true
            },
            {
              key: "gridData",
              fn: function(props) {
                return _vm._l(props.data, function(tr, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr, attrs: { data: tr } },
                    [
                      _c("vs-td", { key: "id" }, [
                        _c("div", [_vm._v(_vm._s(tr.id))])
                      ]),
                      _c("vs-td", { key: "description" }, [
                        _c("div", [_vm._v(_vm._s(tr.description || "-"))])
                      ]),
                      _c("vs-td", { key: "legal_entity_name" }, [
                        _c("div", [
                          _vm._v(_vm._s(tr.legal_entity_name || "Global"))
                        ])
                      ]),
                      _c("vs-td", { key: "created_at" }, [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$utils.format.date(tr.created_at)))
                        ])
                      ]),
                      _c(
                        "vs-td",
                        [
                          _vm._t(
                            "actions",
                            [
                              _c(
                                "div",
                                { staticClass: "flex flex-row gap-2" },
                                [
                                  _c("feather-icon", {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value:
                                          "reporting_channel_handling.configuration.edit",
                                        expression:
                                          "`reporting_channel_handling.configuration.edit`"
                                      },
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top",
                                        value: {
                                          content: "Editar configuração",
                                          delay: { show: 100, hide: 100 }
                                        },
                                        expression:
                                          "{\n                  content: 'Editar configuração',\n                  delay: { show: 100, hide: 100 }\n                }",
                                        modifiers: { top: true }
                                      }
                                    ],
                                    staticClass:
                                      "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                                    attrs: { icon: "EditIcon" },
                                    on: {
                                      click: function($event) {
                                        return _vm.edit(tr.id)
                                      }
                                    }
                                  }),
                                  _c("feather-icon", {
                                    directives: [
                                      {
                                        name: "permission",
                                        rawName: "v-permission",
                                        value:
                                          "reporting_channel_handling.configuration.delete",
                                        expression:
                                          "\n                  `reporting_channel_handling.configuration.delete`\n                "
                                      },
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top",
                                        value: {
                                          content: "Excluir configuração",
                                          delay: { show: 100, hide: 100 }
                                        },
                                        expression:
                                          "{\n                  content: 'Excluir configuração',\n                  delay: { show: 100, hide: 100 }\n                }",
                                        modifiers: { top: true }
                                      }
                                    ],
                                    staticClass:
                                      "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                                    attrs: { icon: "Trash2Icon" },
                                    on: {
                                      click: function($event) {
                                        return _vm.destroy(tr.id)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            {
                              row: tr,
                              data: props.data,
                              indextr: indextr,
                              methods: {
                                edit: props.edit,
                                destroy: props.destroy
                              }
                            }
                          )
                        ],
                        2
                      )
                    ],
                    1
                  )
                })
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }